import { Navigate } from 'react-router-dom'

import OffersManagement from 'src/modules/OffersManagement/OffersManagement'
import DiscoverPage from './DiscoverPage'

export const discoverRoutes = {
  path: '/discover',
  name: 'Discover',
  element: <DiscoverPage />,
  children: [
    { path: '*', index: true, element: <Navigate to='all-offers' replace /> },
    {
      path: 'all-offers',
      element: <OffersManagement tab='all' />,
    },
    {
      path: 'my-offers',
      element: <OffersManagement tab='my' />,
    },
    {
      path: 'private-offers',
      element: <OffersManagement tab='private' />,
    },
  ],
}
